import { twMerge } from 'tailwind-merge';

export enum PopoverPanelPlacement {
  TopLeft = 'topLeft',
  TopCenter = 'topCenter',
  TopRight = 'topRight',
  RightTop = 'rightTop',
  RightCenter = 'rightCenter',
  RightBottom = 'rightBottom',
  BottomLeft = 'bottomLeft',
  BottomCenter = 'bottomCenter',
  BottomRight = 'bottomRight',
  LeftTop = 'leftTop',
  LeftCenter = 'leftCenter',
  LeftBottom = 'leftBottom',
}

export const popoverUIMenuClasses =
  'px-0 bg-white dark:bg-slate-900 text-slate-600 dark:text-slate-200 shadow-lg rounded-lg ' +
  'border-2 border-slate-200 dark:border-slate-700 overflow-hidden';

export const placementReset =
  'top-auto left-auto right-auto bottom-auto translate-x-0 translate-y-0 m-0';

export const popoverPanelPlacementClasses = {
  [PopoverPanelPlacement.TopLeft]: twMerge(
    placementReset,
    'left-0 bottom-full mb-2',
  ),
  [PopoverPanelPlacement.TopCenter]: twMerge(
    placementReset,
    'left-1/2 -translate-x-1/2 bottom-full mb-2',
  ),
  [PopoverPanelPlacement.TopRight]: twMerge(
    placementReset,
    'right-0 bottom-full mb-2',
  ),
  [PopoverPanelPlacement.RightTop]: twMerge(
    placementReset,
    'left-full bottom-0 ml-2',
  ),
  [PopoverPanelPlacement.RightCenter]: twMerge(
    placementReset,
    'left-full top-1/2 -translate-y-1/2 ml-2',
  ),
  [PopoverPanelPlacement.RightBottom]: twMerge(
    placementReset,
    'left-full top-0 ml-2',
  ),
  [PopoverPanelPlacement.BottomLeft]: twMerge(
    placementReset,
    'left-0 top-full mt-2',
  ),
  [PopoverPanelPlacement.BottomCenter]: twMerge(
    placementReset,
    'left-1/2 -translate-x-1/2 top-full mt-2',
  ),
  [PopoverPanelPlacement.BottomRight]: twMerge(
    placementReset,
    'right-0 top-full mt-2',
  ),
  [PopoverPanelPlacement.LeftTop]: twMerge(
    placementReset,
    'bottom-0 right-full mr-2',
  ),
  [PopoverPanelPlacement.LeftCenter]: twMerge(
    placementReset,
    'top-1/2 -translate-y-1/2 right-full mr-2',
  ),
  [PopoverPanelPlacement.LeftBottom]: twMerge(
    placementReset,
    'top-0 right-full mr-2',
  ),
};
